import { Fragment } from "react";
import clsx from "clsx";
import { HeroTitle, TextBadge } from "components/atoms/Text";
import { PrimaryButton, SurfaceButton } from "components/atoms/Button";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto",
                "flex flex-col tablet:flex-row desktop:flex-row justify-between",
                "px-6 tablet:pl-8 desktop:pl-[120px] pb-[96px] phone:pb-12 phone:mt-8 tablet:pb-[64px] mt-[72px] tablet:mt-12",
                "tablet:pr-2 desktop:pr-12 overflow-hidden"
            )}>
                <div className="w-full tablet:max-w-[410px] desktop:max-w-[550px]">
                    <TextBadge>Dedicated Proxy</TextBadge>
                    <HeroTitle classNames="tablet:!text-heading-2">Dedicated HTTP Proxies</HeroTitle>
                    <p className="max-w-[499px] tablet:max-w-[397px] pt-4 font-normal relative z-30 phone:text-lg text-neutral-50 tablet:text-[16px] desktop:text-[16px] tracking-text !leading-[30.6px] tablet:!leading-[27.2px]">
                        Vel accumsan, aliquet fermentum suspendisse. Nec quis mauris eu, ut morbi sapien. Magna magna eget in feugiat amet aliquet.
                    </p>
                    <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-6 space-y-4 md:space-y-0 mt-8 phone:mt-8 tablet:mt-8">
                        <PrimaryButton>Get Started</PrimaryButton>
                        <SurfaceButton>See Pricing</SurfaceButton>
                    </div>
                </div>
                <div className="w-full tablet:max-w-[600px] tablet:pt-[5px] max-w-[704px] pl-[30px] tablet:pl-0 tablet:pr-[56px] phone:pl-0 phone:mt-10">
                    <img src="/images/proxy/dedicated.svg" className="tablet:scale-[.97] w-[704px] tablet:h-[350px] h-[450px] phone:h-[215px]" alt="proxy-hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;